import React from "react";

const BatchIcon1 = ({ width, height, color }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.6675 3.75H31.25V1.25C31.25 0.55875 30.6912 0 30 0C29.3088 0 28.75 0.55875 28.75 1.25V3.75H21.25V1.25C21.25 0.55875 20.69 0 20 0C19.31 0 18.75 0.55875 18.75 1.25V3.75H11.25V1.25C11.25 0.55875 10.69 0 10 0C9.31 0 8.75 0.55875 8.75 1.25V3.75H3.33375C1.4925 3.75 0 5.24125 0 7.0825V36.6663C0 38.5075 1.4925 40 3.33375 40H36.6675C38.5088 40 40 38.5075 40 36.6663V7.0825C40 5.24125 38.5088 3.75 36.6675 3.75ZM37.5 36.6663C37.5 37.1263 37.1263 37.5 36.6675 37.5H3.33375C2.87375 37.5 2.5 37.1263 2.5 36.6663V7.0825C2.5 6.62375 2.87375 6.25 3.33375 6.25H8.75V8.75C8.75 9.44125 9.31 10 10 10C10.69 10 11.25 9.44125 11.25 8.75V6.25H18.75V8.75C18.75 9.44125 19.31 10 20 10C20.69 10 21.25 9.44125 21.25 8.75V6.25H28.75V8.75C28.75 9.44125 29.3088 10 30 10C30.6912 10 31.25 9.44125 31.25 8.75V6.25H36.6675C37.1263 6.25 37.5 6.62375 37.5 7.0825V36.6663Z"
        fill="#435CFF"
      />
      <path d="M14 15H9V19H14V15Z" fill="#435CFF" />
      <path d="M14 21H9V25H14V21Z" fill="#435CFF" />
      <path d="M14 27H9V31H14V27Z" fill="#435CFF" />
      <path d="M23 27H18V31H23V27Z" fill="#435CFF" />
      <path d="M23 21H18V25H23V21Z" fill="#435CFF" />
      <path d="M23 15H18V19H23V15Z" fill="#435CFF" />
      <path d="M31 27H26V31H31V27Z" fill="#435CFF" />
      <path d="M31 21H26V25H31V21Z" fill="#435CFF" />
      <path d="M31 15H26V19H31V15Z" fill="#435CFF" />
    </svg>
  );
};

export default BatchIcon1;
